module.exports = __webpack_public_path__ + "static/media/no_product_available.50ad67dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_product_available.svg
// module id = 342
// module chunks = 21